export default "__VITE_ASSET__BkUCfCkX__"